module.exports = __webpack_public_path__ + "img/CY120029.6aab9410.png";